import { Pipe, PipeTransform } from '@angular/core';
import { List, sumBy } from 'lodash';

@Pipe({
  name: 'sumBy',
  standalone: true,
})
export class SumByPipe implements PipeTransform {
  transform(
    value: List<unknown> | null | undefined,
    iteratee?: string | ((value: unknown) => number) | undefined
  ): number {
    return sumBy(value, iteratee);
  }
}
